export const resolveStyledSlots = (styles, theme) => typeof styles === "function" ? styles(theme) : styles;
const normalizeStateSelectors = style => {
  if (!style || typeof style !== "object") return style;
  return Object.entries(style).reduce((acc, [key, value]) => {
    const normalizedKey = key.replace(/\$checked/g, ".Mui-checked").replace(/\$selected/g, ".Mui-selected").replace(/\$expanded/g, ".Mui-expanded").replace(/\$track/g, ".MuiSwitch-track");
    acc[normalizedKey] = normalizeStateSelectors(value);
    return acc;
  }, {});
};
export const styledSlots = (styles = {}) => {
  const normalized = Object.entries(styles).reduce((acc, [slot, style]) => {
    acc[slot] = normalizeStateSelectors(style);
    return acc;
  }, {});
  return {
    ...(normalized.root || {}),
    ...(normalized.disabled ? {
      "&.Mui-disabled": normalized.disabled
    } : {}),
    ...(normalized.indicator ? {
      "& .MuiTabs-indicator": normalized.indicator
    } : {}),
    ...(normalized.label ? {
      "& .MuiButton-label": normalized.label
    } : {}),
    ...(normalized.switchBase ? {
      "& .MuiSwitch-switchBase": normalized.switchBase
    } : {}),
    ...(normalized.track ? {
      "& .MuiSwitch-track": normalized.track
    } : {}),
    ...(normalized.content ? {
      "& .MuiAccordionSummary-content": normalized.content
    } : {})
  };
};
